export default "__VITE_ASSET__82bfa5d1__"